import {getOfferTypeNamePluralCapital} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";

interface IGetInvestmentApartmentsAmplitudeItemListNameParams {
    offerType: OfferType;
    isApartment?: boolean;
}

export const getInvestmentApartmentsAmplitudeItemListName = ({offerType, isApartment}: IGetInvestmentApartmentsAmplitudeItemListNameParams): string =>
    `${isApartment ? "Apartamenty" : getOfferTypeNamePluralCapital(offerType === OfferType.MODULAR_HOUSE ? OfferType.HOUSE : offerType)} w inwestycji`;
import {getOfferTypeNamePluralCapital} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";

interface IGetInvestmentApartmentsAmplitudeItemListNameParams {
    offerType: OfferType;
    isApartment?: boolean;
}

export const getInvestmentApartmentsAmplitudeItemListName = ({offerType, isApartment}: IGetInvestmentApartmentsAmplitudeItemListNameParams): string =>
    `${isApartment ? "Apartamenty" : getOfferTypeNamePluralCapital(offerType === OfferType.MODULAR_HOUSE ? OfferType.HOUSE : offerType)} w inwestycji`;
